import React, { useContext } from 'react';
import styled from 'styled-components';
import color from 'styles/colors';
import { ROUTE_HOME, Brand } from 'constants/index';
import { setLoading } from 'context/state/reducer';
import { AppContext } from 'context/GlobalContextProvider';
import { FoxLogo, FoxSportsLogo, NationLogo } from '../Icons';
import Link from '../Link';

type TBrandLogo = {
  [key: string]: React.ElementType;
};

const BrandLogo: TBrandLogo = {
  [Brand.FOX]: FoxLogo,
  [Brand.SPORTS]: FoxSportsLogo,
  [Brand.NATION]: NationLogo,
};

const Logo = BrandLogo[process.env.NEXT_PUBLIC_BRAND as string];
const BRAND = process.env.NEXT_PUBLIC_BRAND;

const Header = (): JSX.Element => {
  const { dispatch } = useContext(AppContext);
  return (
    <StyledHeader>
      <Link className="logo" href={ROUTE_HOME}>
        <Logo onClick={() => dispatch(setLoading(false))} />
      </Link>
    </StyledHeader>
  );
};

export default Header;

const StyledHeader = styled.header`
  z-index: 10;
  display: flex;
  width: 100%;
  height: 80px;
  align-items: center;
  justify-content: center;
  border: none;
  margin: 0;
  background: ${({ theme }) => theme?.colors?.header};
  .logo {
    display: block;
    svg {
      fill: ${color.white};
      width: 100%;
      max-width: ${BRAND === Brand.FOX ? '150px' : '80px'};
      max-height: 80px;
    }
  }
`;
